import { TablePagination, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { getMaestras } from "../../actions/generation-contarct-action";
import { getActiveRegionals } from "../../actions/regional-actions";
import { useStateValue } from "../../context/store";
import SearchEndowment from "./searchEndowment";
import Search from "../../images/icons/search.svg";
import { styles } from "../styles";
import {
  createCardFormat,
  getEndowmentDelivery,
} from "../../actions/endowment-delivery-action";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import AccordionEndowment from "./accordionEndowment";
import GenerateCardFormat from "./generateCardFormat";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { REQUIRED_MESSAGE } from "../../constants";
import { downloadPDF } from "../../utils/functionsUtils";
import { permissionsConstans } from "../../constansPermissions";
import TakeFingerprintModal from "./takeFingerprintModal";

const defaultValue = {
  name: "",
  document: "",
  documentType: "",
  deliverDate: "",
  linkageType: "",
};

const EndowmentDelivery = () => {
  const classes = styles();
  const soloLetras = /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g;
  const [{ filterEndowmentDelivery }, dispatch] = useStateValue();
  const [maestras, setMaestras] = useState([]);
  const [regionals, setRegionals] = useState([]);
  const [openCard, setOpenCard] = useState(false);
  const [dataCardFormat, setDataCardFormat] = useState({});
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isDisabledBtnCard, setIsDisabledBtnCard] = useState(false);
  const [openModalFinger, setOpenModalFinger] = useState(false);
  const [typeFinger, setTypeFinger] = useState("");

  const [data, setData] = useState({
    firstName: null,
    surname: null,
    documentType: null,
    document: null,
    regional: null,
    deliverDate: null,
    //regionalId: null,
    //status: null,
    initDate: null,
    endDate: null,
  });

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    threeButtons: false,
    type: "",
    open: false,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const schema = yup.object().shape({
    name: yup
      .string()
      .nullable()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(soloLetras, "Ingrese un nombre válido"),
    documentType: yup.string().nullable().notRequired(),
    document: yup
      .string()
      .nullable()
      .notRequired()
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(16, "Ingrese máximo 16 caracteres")
      .matches(/^(([0-9])+?)*$/g, "Ingrese solo números"),
    deliverDate: yup
      .date()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(
        new Date(1899, 11, 31, 23, 59, 29),
        `Ingrese una fecha superior al año 1900`
      )
      .typeError("Ingrese un formato de fecha válido"),
    linkageType: yup.string().nullable().required(REQUIRED_MESSAGE),
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    initialStateForm: defaultValue,
    mode: "all",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    if (isOpenModal) {
      setValue("name", dataCardFormat?.employee?.fullName);
      setValue("document", dataCardFormat?.employee?.document);
      setValue("documentType", dataCardFormat?.employee?.documentType);
    }
  }, [isOpenModal, dataCardFormat, setValue]);

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Entrega de dotación",
      breadCrumbSubText: "Entrega de dotación",
      index: 31,
    });
  }, [dispatch]);

  useEffect(() => {
    const getListTeachers = async () => {
      const response = await getMaestras();
      setMaestras(response?.data?.maestras);
    };
    getListTeachers();
  }, []);

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const handleClickCloseSuccess = () => {
    setMessage({ ...message, open: false });
    getAllEndowmentDelivery();
  };

  const messageError = (msj, type, action) => {
    setMessage({
      description: msj,
      textButtonSubmit: "ACEPTAR",
      handleClick: () => action(),
      oneButtons: true,
      type: type,
      open: true,
    });
  };

  const getAllEndowmentDelivery = async () => {
    const response = await getEndowmentDelivery(
      {
        employeeName: data.firstName === "" ? null : data.firstName,
        employeeSurname: data.surname === "" ? null : data.surname,
        regionalId: data.regional === "" ? null : data.regional,
        documentType: data.documentType === "" ? null : data.documentType,
        document: data.document === "" ? null : data.document,
        licenseStartDate: data.initDate === "" ? null : data.initDate,
        licenseEndDate: data.endDate === "" ? null : data.endDate,
        deliveryDate: data.deliverDate === "" ? null : data.deliverDate,
      },
      paginadorRequest
    );
    if (response && (response.status === 200 || response.status === 201)) {
      const data = response?.data;
      if (data?.endowmentPage?.content?.length > 0) {
        setPaginadorResponse({
          data: data?.endowmentPage?.content,
          totalRows: data?.endowmentPage?.totalElements,
          pageSize: data?.endowmentPage?.size,
          pageNumber: data?.endowmentPage?.page,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
      const msj = response?.data?.detail
        ? response?.data?.detail
        : response?.data?.error;
      messageError(msj, "WARNING", handleClickClose);
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  useEffect(() => {
    getAllEndowmentDelivery();
  }, [paginadorRequest]);

  if (
    filterEndowmentDelivery &&
    filterEndowmentDelivery.isFilter &&
    data !== filterEndowmentDelivery.filter
  ) {
    const filter = filterEndowmentDelivery?.filter;
    data.firstName = filter?.firstName;
    data.surname = filter?.surname;
    data.documentType = filter?.documentType;
    data.document = filter?.document;
    data.regional = filter?.regional;
    data.deliverDate = filter?.deliverDate;
    data.initDate = filter?.initDate;
    data.endDate = filter?.endDate;
    paginadorRequest.page = 0;
    dispatch({
      type: "SET_FILTER_ENDOWMENT",
      isFilter: false,
    });
    getAllEndowmentDelivery();
  }

  useEffect(() => {
    const getRegional = async () => {
      const response = await getActiveRegionals();
      setRegionals(response?.data?.regionalList);
    };
    getRegional();
  }, []);

  const closeModalCard = () => {
    setOpenCard(false);
    setIsOpenModal(false);
    setIsDisabledBtnCard(false);
  };

  const requestMessage = (msj, type, action) => {
    setIsDisabledBtnCard(false);
    setMessage({
      description: msj,
      textButtonSubmit: "Aceptar",
      handleClick: () => action(),
      type: type,
      oneButtons: true,
      open: true,
    });
  };

  const onSubmitCard = (data) => {
    const newData = {
      //deliveryDate: moment(data.deliverDate).format("YYYY-MM-DDTHH:mm"),
      typeOfLink: data.linkageType,
      //isCard: true
    };
    setMessage({
      description: "¿Está seguro que desea generar formato entrega de carnet?",
      textButtonSubmit: "ACEPTAR",
      handleClick: () => handleClickCardFormat(newData),
      handleClickOut: () => handleClickClose(),
      type: "QUESTION",
      open: true,
    });
  };

  const handleClickCardFormat = async (info) => {
    setIsDisabledBtnCard(true);
    setMessage({ ...message, open: false });
    const response = await createCardFormat(dataCardFormat?.id, info);
    if (response?.status === 200 || response?.status === 201) {
      const msj =
        "El formato de entrega de carnet se ha generado de forma exitosa.";
      requestMessage(msj, "SUCCESS", handleClickSuccess);
      const pdf = response?.data?.cardDocument?.documentResponseDTO;
      if (pdf?.data) {
        downloadPDF(pdf?.data, "Formato de carnet.pdf");
      }
    } else if (response?.status > 399) {
      const msj = response?.data?.detail
        ? response?.data?.detail
        : "Ocurrió un error procesando la solicitud, inténtelo nuevamente";
      requestMessage(msj, "WARNING", handleClickClose);
    } else {
      const msj =
        "Ocurrió un error procesando la solicitud, inténtelo nuevamente";
      requestMessage(msj, "WARNING", handleClickClose);
    }
  };

  const handleClickSuccess = async () => {
    setMessage({ ...message, open: false });
    closeModalCard();
    getAllEndowmentDelivery();
  };

  const validPerEndowment = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "DOT");

    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.DOT_CONSULTAR
      )
    ) {
      return (
        <React.Fragment>
          <SearchEndowment maestras={maestras} regionals={regionals} />
        </React.Fragment>
      );
    } else return null;
  };

  const handleClickFingerPrint = (info, type) => {
    setTypeFinger(type);
    setMessage({
      description: "Ingrese la huella",
      textButtonSubmit: "ACEPTAR",
      handleClick: () => handleClickSign(info?.id),
      handleClickOut: () => handleClickClose(),
      type: "QUESTION",
      open: true,
    });
  };

  const handleClickSign = () => {
    setMessage({ ...message, open: false });
    setOpenModalFinger(true);
  };

  const closeModalFinger = () => {
    setOpenModalFinger(false);
    setTypeFinger("");
  };

  return (
    <div>
      <GenerateCardFormat
        openCard={openCard}
        closeModalCard={closeModalCard}
        maestras={maestras}
        onSubmit={onSubmitCard}
        dataCardFormat={dataCardFormat}
        register={register}
        control={control}
        handleSubmit={handleSubmit}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        isDisabledBtnCard={isDisabledBtnCard}
      />

      {validPerEndowment()}

      {paginadorResponse?.data.length > 0
        ? paginadorResponse?.data.map((data) => (
            <AccordionEndowment
              data={data}
              maestras={maestras}
              message={message}
              setMessage={setMessage}
              handleClickClose={handleClickClose}
              handleClickCloseSuccess={handleClickCloseSuccess}
              setOpenCard={setOpenCard}
              setDataCardFormat={setDataCardFormat}
              setIsOpenModal={setIsOpenModal}
              requestMessage={requestMessage}
              handleClickFingerPrint={handleClickFingerPrint}
            />
          ))
        : null}

      {paginadorResponse?.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          labelRowsPerPage="Registros por página"
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
        />
      ) : (
        <React.Fragment>
          <div className={classes.messageSearch}>
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado
            </Typography>
          </div>
        </React.Fragment>
      )}

      <TakeFingerprintModal
        openModal={openModalFinger}
        closeModalFinger={closeModalFinger}
        setMessage={setMessage}
        message={message}
        requestMessage={requestMessage}
        typeFinger={typeFinger}
        getAllEndowmentDelivery={getAllEndowmentDelivery}
      />

      <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        threeButtons={message.threeButtons}
        type={message.type}
        open={message.open}
      />
    </div>
  );
};

export default EndowmentDelivery;
